export const GET_STRIPE_TOKEN_REQUESTED = "GET_STRIPE_TOKEN_REQUESTED";
export const GET_STRIPE_TOKEN_FULFILLED = "GET_STRIPE_TOKEN_FULFILLED";
export const GET_STRIPE_TOKEN_REJECTED = "GET_STRIPE_TOKEN_REJECTED";
export const RESET_STRIPE_TOKEN = "RESET_STRIPE_TOKEN";
